import './sass/main.scss';
import './js/keyWordSearch';
import './js/footerStudents'; 
import './js/apiService';
import './js/apiResultsExample';
import './js/userListBuilder';
import './js/renderMainPage';
import './js/openLibrary';
import './js/modalFilmCard';
import './js/pagination';
import './js/switchHeader';
import './js/btnScrollTop';
import './js/auth';
import './js/trailer'

